<style scoped>
.navbrand-supersafra{
  text-decoration: none !important;
  font-family: 'Libre Baskerville', serif; 
  color: #3e4095; 
  text-shadow: white 1px 1px 1px; 
  letter-spacing: -4px;
  vertical-align: text-middle; 
  font-size: 20px;
}

.navbrand-supersafra:hover{
  text-decoration: none !important;
  font-family: 'Libre Baskerville', serif; 
  color: #3e4095; 
  text-shadow: white 1px 1px 1px; 
  letter-spacing: -4px;
  vertical-align: text-middle; 
  font-size: 20px;
}

.navbrand-supersafra:focus{
  text-decoration: none !important;
  font-family: 'Libre Baskerville', serif; 
  color: #3e4095; 
  text-shadow: white 1px 1px 1px; 
  letter-spacing: -4px;
  vertical-align: text-middle; 
  font-size: 20px;
}

.icone-navbrand-supersafra{
  width: 27.5px;
}
</style>
<template>
    <div class="container-fluid">
        <!--/ Nav Star /-->
        <nav class="navbar navbar-b navbar-trans bg-white navbar-expand-lg fixed-top navbar-reduce" id="mainNav">
            <div class="container">
            <a class="js-scroll" href="#page-top">
                <div style="float: left" class="mr-1">
                    <img :src="url+'/images/logo.webp'" alt="Logomarca do Site" class="icone-navbrand-supersafra">
                </div>
                <div class="ml-1 text-center" style="float: right">
                    <div class="text-uppercase navbrand-supersafra">Grupo&nbsp; Super&nbsp;&nbsp; Safra<br></div>
                    <div style="margin-top: -10px;"><strong style="font-family:'Sarah-script'; color: #994234; margin-bottom: -15px;">Tecnologia a serviço da terra!</strong></div>
                    <!-- <p class="intro-subtitle"><span class="text-slider-items">
                        Tecnologia a serviço da terra,Tecnologia a serviço do campo,Tecnologia a serviço da agricultura,Tecnologia a serviço da pecuária,Tecnologia a seu serviço!
                    </span><strong class="text-slider" style="font-family:'Sarah-script'; color: #994234;"></strong></p> -->
                </div>
            </a>
            <button class="navbar-toggler collapsed" type="button" data-toggle="collapse" data-target="#navbarDefault"
                aria-controls="navbarDefault" aria-expanded="false" aria-label="Toggle navigation">
                <span></span>
                <span></span>
                <span></span>
            </button>
            <div class="navbar-collapse collapse justify-content-end" id="navbarDefault">
                <ul class="navbar-nav">
                <li class="nav-item">
                    <a class="nav-link js-scroll active" href="#home"><i class="fas fa-home"></i> Início</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link js-scroll" href="#about"><i class="fas fa-address-card"></i> Sobre</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link js-scroll" href="#service"><i class="fas fa-concierge-bell"></i> Serviços</a>
                </li>
                <!-- <li class="nav-item">
                    <a class="nav-link js-scroll" href="#work"><i class="fas fa-gifts"></i> Produtos</a>
                </li> -->
                <li class="nav-item">
                    <a class="nav-link js-scroll" href="#blog"><i class="fas fa-blog"></i> Blog</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link js-scroll" href="#contact"><i class="fab fa-whatsapp"></i> Contato</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link js-scroll" href="/login"><i class="fas fa-sign-in-alt"></i> Acessar</a>
                </li>
                </ul>
            </div>
            </div>
        </nav>
        <!--/ Nav End /-->
    </div>
</template>

<script>
    export default {
        data() {
            return {
                filial_escolhida: window.filial,
                filial: '',
                filiais: window.filiais,
                url: 'https://'+window.location.host
            }
        },
        mounted(){
            if(this.filial_escolhida != null && this.filial_escolhida != '' && typeof this.filial_escolhida != 'undefined'){
                this.filiais.forEach((el, i, arr) => {
                    if(el.area_url == this.filial_escolhida){
                        this.filial = el;
                    }
                })
            }
        }
    }
</script>
